/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Battery Icon component.
 */
export const BatteryIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19760)'>
        <path d='M13.334 11.5C13.334 11.7761 13.1101 12 12.834 12L0.5 12C0.223858 12 -3.39906e-07 11.7761 -3.27835e-07 11.5L-2.18557e-08 4.5C-9.78513e-09 4.22386 0.223858 4 0.5 4L12.834 4C13.1101 4 13.334 4.22386 13.334 4.5L13.334 11.5ZM11.999 5.13379L1.13184 5.13379L1.13184 10.8662L11.999 10.8662L11.999 5.13379ZM1.53223 10.4668L1.53223 5.5332L3.38477 5.5332L3.38477 10.4668L1.53223 10.4668Z' fill={dlsColor('caRed')} />
        <rect x='16' y='5.33398' width='5.33333' height='1.3334' transform='rotate(90 16 5.33398)' fill={dlsColor('caRed')} />
        <path d='M13.334 11.5C13.334 11.7761 13.1101 12 12.834 12L0.5 12C0.223858 12 -3.39906e-07 11.7761 -3.27835e-07 11.5L-2.18557e-08 4.5C-9.78513e-09 4.22386 0.223858 4 0.5 4L12.834 4C13.1101 4 13.334 4.22386 13.334 4.5L13.334 11.5ZM11.999 5.13379L1.13184 5.13379L1.13184 10.8662L11.999 10.8662L11.999 5.13379ZM1.53223 10.4668L1.53223 5.5332L11.6084 5.5332L11.6084 10.4668L1.53223 10.4668Z' fill={iconColor} />
        <rect x='16' y='5.33398' width='5.33333' height='1.3334' transform='rotate(90 16 5.33398)' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_14304_19760'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BatteryIcon;
